import "./CookieBanner.scss";
import cn from "classnames";

const CookieBanner = ({ hide }) => {
  return (
    <div className={cn("cookie__policy-wrap", { hide: hide })}>
      <p className="text">
        We use cookies to make your experience better! If you continue to use
        this site we will assume that you are happy with it.
      </p>
      <button className="accept" data-attr="cookies">
        Agree & Close
      </button>
    </div>
  );
};
export default CookieBanner;
